import { render, staticRenderFns } from "./self-report-transfer.vue?vue&type=template&id=0aab020c"
import script from "./self-report-transfer.vue?vue&type=script&lang=js"
export * from "./self-report-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports